module.exports = __webpack_public_path__ + "media/images/carrusel/delegaciones1-483df225cb27aa84754a2d2558febdd6.jpg";